<template>
  <slot />
</template>

<script setup>
import { col as componentProps } from "./props";
import { useCol } from "./composables/useCol";

// SpCol's template is `<slot />`, so there is no shadow-DOM root for Vue to
// inherit the host's `class` / `style` onto; the host keeps them natively.
// TODO(#26705): drop once SpCol moves off the slot-only template.
defineOptions({
  inheritAttrs: false,
});

defineProps(componentProps);

useCol();
</script>

<style lang="scss">
@import "./styles/col";
</style>
